import React, { useState, useEffect } from 'react';
import { whatsappConfig } from '../utils/mockData';

const WhatsAppIcon = ({ size = 28 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    aria-hidden="true"
    style={{ display: 'block' }}
  >
    <path
      fill="#ffffff"
      d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413"
    />
  </svg>
);

const WhatsAppButton = ({ selectedPiece }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const message = selectedPiece
      ? `Hello! I'm interested in the "${selectedPiece.name}" piece. ${whatsappConfig.message}`
      : whatsappConfig.message;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${whatsappConfig.number}?text=${encodedMessage}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div
      style={styles.container}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      {isExpanded && (
        <div style={styles.messagePreview} className="fade-in">
          <p style={styles.previewTitle}>Begin Your Journey</p>
          <p style={styles.previewText}>
            {selectedPiece
              ? `Inquire about ${selectedPiece.name}`
              : 'Connect with our atelier'
            }
          </p>
        </div>
      )}

      <button
        onClick={handleClick}
        style={styles.button}
        aria-label="Contact via WhatsApp"
        data-testid="whatsapp-button"
      >
        <WhatsAppIcon size={28} />
      </button>
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    bottom: '32px',
    right: '32px',
    zIndex: 90,
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  messagePreview: {
    background: 'var(--bg-primary)',
    border: '1px solid var(--border-light)',
    padding: '16px 20px',
    maxWidth: '220px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  },
  previewTitle: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '10px',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: 'var(--accent-gold)',
    marginBottom: '6px',
  },
  previewText: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '14px',
    color: 'var(--text-secondary)',
    lineHeight: '1.5',
  },
  button: {
    width: '58px',
    height: '58px',
    borderRadius: '50%',
    background: '#25D366',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease',
    boxShadow: '0 8px 24px rgba(37, 211, 102, 0.35)',
  },
};

// Add hover styles
const buttonStyles = document.createElement('style');
buttonStyles.textContent = `
  [data-testid="whatsapp-button"]:hover {
    background: #1ebe5a;
    transform: scale(1.07);
    box-shadow: 0 10px 32px rgba(37, 211, 102, 0.5);
  }
`;
document.head.appendChild(buttonStyles);

export default WhatsAppButton;
